<template>
  <a-row>
    <a-menu
      v-model="currentMenu"
      mode="horizontal"
      style="font-size: 20px; margin-bottom: 25px"
    >
      <a-menu-item
        v-if="settings.status_license.condition != 'empty'"
        key="main"
      >
        <a-icon type="global" />
        {{ $t("Main") }}
      </a-menu-item>
      <a-menu-item
        v-if="settings.status_license.condition != 'empty'"
        key="matrix"
      >
        <a-icon type="solution" />
        {{ $t("Access matrix") }}
      </a-menu-item>
      <a-menu-item key="license">
        <a-icon type="safety-certificate" />
        {{ $t("license") }}
      </a-menu-item>
    </a-menu>
    <a-col
      :span="24"
      v-if="
        settings.status_license.condition != 'empty' && currentMenu[0] == 'main'
      "
    >
      <a-form
        id="settings_main_form"
        :form="form_main"
        @submit="handleSubmit_main"
        :label-col="{
          xs: { span: 24 },
          sm: { span: 8 },
        }"
        labelAlign="left"
        :wrapper-col="{
          xs: { span: 24 },
          sm: { span: 12 },
        }"
      >
        <a-form-item :label="$t('Document folder')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t("Select a storage location from Bitrix24.Drive folders")
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                auto
                showSearch
                optionFilterProp="children"
                v-decorator="[
                  'folder',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.folder,
                  },
                ]"
              >
                <a-select-option
                  v-for="folder in settings['data_getchildren']"
                  :key="folder.NAME"
                  :value="folder.ID"
                  >{{ folder.NAME }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item :label="$t('Responsible for registration')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Select user(-s) who performs the initial registration of the document"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                mode="multiple"
                optionFilterProp="children"
                :dropdownMatchSelectWidth="false"
                v-decorator="[
                  'responsible',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.responsible,
                  },
                ]"
              >
                <a-select-option
                  v-for="user in settings['data_user']"
                  :value="user.ID"
                  :key="user.NAME + ' ' + user.LAST_NAME"
                  >{{ user.NAME + " " + user.LAST_NAME }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <!-- <a-form-item :label="$t('Mail folder')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Select a folder from Bitrix24.Drive with incoming documents from mail"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                showSearch
                optionFilterProp="children"
                v-decorator="[
                  'mail_folder',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.mail_folder,
                  },
                ]"
              >
                <a-select-option
                  v-for="folder in settings['data_getchildren']"
                  :key="folder.NAME"
                  :value="folder.ID"
                  >{{ folder.NAME }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </a-form-item> -->

        <!-- <a-form-item :label="$t('Mail responsible')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "User's or users' mail from which incoming documents are added to the folder above"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                optionFilterProp="children"
                :dropdownMatchSelectWidth="false"
                v-decorator="[
                  'mail_user',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.mail_user,
                  },
                ]"
              >
                <a-select-option
                  v-for="user in settings['data_user']"
                  :value="user.ID"
                  :key="user.NAME + ' ' + user.LAST_NAME"
                  >{{ user.NAME + " " + user.LAST_NAME }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </a-form-item> -->

        <a-form-item :label="$t('Company type')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Select a Company Type that defines the companies belonging to the portal owner. Set it up in the Access Matrix."
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                showSearch
                optionFilterProp="children"
                mode="multiple"
                v-decorator="[
                  'companyType',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.companyType,
                  },
                ]"
              >
                <a-select-option
                  v-for="comp in settings['crm_status_list']"
                  :value="comp.ID"
                  :key="comp.NAME"
                  >{{ comp.NAME }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item :label="$t('NIP Application ID')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Synchronization with “Check the company by NIP” app: enter the application ID (it can be viewed in the address bar of the application page)"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-input-number
                style="width: 100%"
                v-decorator="[
                  'nip',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.nip,
                  },
                ]"
                :min="1"
              />
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item :label="$t('NIP field name')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Select a unique field by which companies is differ from one another"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                showSearch
                optionFilterProp="children"
                v-decorator="[
                  'nip_field',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.nip_field,
                  },
                ]"
              >
                <a-select-option
                  v-for="key in settings['userfields']"
                  :value="key['title']"
                  :key="key['title']"
                  >{{ key["listLabel"] }}</a-select-option
                >
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item :label="$t('Keywords')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Add words to quickly filter and search documents that are similar by a specific criterion"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                :dropdownMatchSelectWidth="false"
                mode="tags"
                v-decorator="[
                  'words',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.words,
                  },
                ]"
              >
                <a-select-option v-for="i in user_val.words" :key="i">{{
                  i
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item :label="$t('Specialization')">
          <a-row type="flex">
            <a-col :span="1">
              <a-tooltip placement="top">
                <template slot="title">{{
                  $t(
                    "Use it to sort documents by different groups, segments, areas or departments"
                  )
                }}</template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </a-col>
            <a-col :span="23">
              <a-select
                :dropdownMatchSelectWidth="false"
                mode="tags"
                v-decorator="[
                  'SPECJALIZACJA',
                  {
                    rules: [{ required: false }],
                    initialValue: user_val.SPECJALIZACJA,
                  },
                ]"
              >
                <a-select-option v-for="i in user_val.SPECJALIZACJA" :key="i">{{
                  i
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item
          align="center"
          :label-col="{ span: 0 }"
          :wrapper-col="{ span: 24 }"
          :help="+`Bitrix24.Drive/archiwum/`"
        >
          <a-tooltip placement="top">
            <template slot="title">{{ $t("archive storage prompt") }}</template>
            <a-button type="primary" html-type="submit">{{
              $t("Save")
            }}</a-button>
          </a-tooltip>
        </a-form-item>
      </a-form>
    </a-col>
    <a-col
      :span="24"
      v-if="
        settings.status_license.condition != 'empty' &&
        currentMenu[0] == 'matrix'
      "
    >
      <a-form
        :form="form_matrix"
        :label-col="{ xs: { span: 24 }, sm: { span: 10 } }"
        :wrapper-col="{ xs: { span: 24 }, sm: { span: 14 } }"
        @submit="handleSubmit_matrix"
      >
        <!-- <a-row :gutter="16"> -->
        <a-row :gutter="16">
          <a-row
            :span="8"
            style="padding-top: 8px"
            :key="index"
            v-for="(item, index) in matrixData()"
          >
            <!-- <a-row class="matrix__elem" :gutter="16"> -->
            <a-row class="matrix__elem">
              <a-row class="title">
                <a
                  :href="`${item.SRC}`"
                  v-if="domain != null"
                  target="_blank"
                  >{{ item.TITLE }}</a
                >
                <span v-else>{{ item.TITLE }}</span>
              </a-row>

              <a-col class="hubLeader" :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <a-form-item
                  :label="$t('Responsible person')"
                  style="margin: 0"
                >
                  <a-tooltip>
                    <template slot="title">{{
                      $t("Full access to all documents and editing stages")
                    }}</template>
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      :dropdownMatchSelectWidth="false"
                      v-decorator="[
                        `${item.ID}.bizLider`,
                        {
                          rules: [{ required: false }],
                          initialValue: Object.keys(settings.matrix).length ? settings.matrix[item.ID].HUBLIDER : '',
                          // initialValue: settings.matrix[item.ID].HUBLIDER,
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="user in settings['data_user']"
                        :value="user.ID"
                        :key="user.NAME + ' ' + user.LAST_NAME"
                        >{{ user.NAME + " " + user.LAST_NAME }}</a-select-option
                      >
                    </a-select>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col
                class="projectAssistant"
                :xs="7"
                :sm="7"
                :md="7"
                :lg="7"
                :xl="7"
              >
                <a-form-item :label="$t('Project assistant')">
                  <a-tooltip>
                    <template slot="title">{{
                      $t("Project assistant description")
                    }}</template>
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      :dropdownMatchSelectWidth="false"
                      v-decorator="[
                        `${item.ID}.asystent`,
                        {
                          rules: [{ required: false }],
                          initialValue: Object.keys(settings.matrix).length ? settings.matrix[item.ID].ASSISTANT : '',
                          // initialValue: settings.matrix[item.ID].ASSISTANT,
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="user in settings['data_user']"
                        :value="user.ID"
                        :key="user.NAME + ' ' + user.LAST_NAME"
                        >{{ user.NAME + " " + user.LAST_NAME }}</a-select-option
                      >
                    </a-select>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col class="private" :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <a-form-item :label="$t('confidential')">
                  <a-tooltip>
                    <template slot="title">{{
                      $t("TooltipPrivateDocuments")
                    }}</template>
                    <a-switch
                      style="margin-left: 30px"
                      :defaultChecked="item.switchDefault"
                      v-decorator="[
                        `${item.ID}.RIGHT`,
                        {
                          rules: [{ required: false }],
                          initialValue: item.switchDefault,
                        },
                      ]"
                    >
                      <a-icon type="close" slot="unCheckedChildren" />
                      <a-icon type="check" slot="checkedChildren" />
                    </a-switch>
                  </a-tooltip>
                </a-form-item>
              </a-col>

              <a-col
                class="responsibleForProcessing"
                :xs="7"
                :sm="7"
                :md="7"
                :lg="7"
                :xl="7"
              >
                <a-form-item :label="$t('responsible_for_processing')">
                  <a-tooltip>
                    <template slot="title">{{
                      $t(
                        "The employee who registers the documents of this company by default"
                      )
                    }}</template>
                    <a-select
                      showSearch
                      optionFilterProp="children"
                      :dropdownMatchSelectWidth="false"
                      v-decorator="[
                        `${item.ID}.respForProc`,
                        {
                          rules: [{ required: false }],
                          initialValue: Object.keys(settings.matrix).length ? settings.matrix[item.ID].respForProc : '',
                          // initialValue: settings.matrix[item.ID].respForProc,
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="user in settings['data_user']"
                        :value="user.ID"
                        :key="user.NAME + ' ' + user.LAST_NAME"
                        >{{ user.NAME + " " + user.LAST_NAME }}</a-select-option
                      >
                    </a-select>
                  </a-tooltip>
                </a-form-item>
              </a-col>
            </a-row>
          </a-row>
        </a-row>

        <a-form-item
          align="center"
          :label-col="{ span: 0 }"
          :wrapper-col="{ span: 24 }"
          style="margin-top: 25px"
        >
          <a-button type="primary" html-type="submit">{{
            $t("Save")
          }}</a-button>
        </a-form-item>
      </a-form>
    </a-col>
    <a-col
      :span="24"
      v-if="
        settings.status_license.condition == 'empty' ||
        currentMenu[0] == 'license'
      "
    >
      <a-form :form="form_license" @submit="handleSubmit_license">
        <a-row>
          <a-col style="text-align: center">
            <a-tooltip>
              <template slot="title">{{
                diffDays() + " " + $t("limit days")
              }}</template>
              <a-progress
                v-if="settings.status_license.condition == 'full'"
                type="dashboard"
                status="active"
                :width="100"
                :percent="(diffDays() * 100) / 365"
                :format="() => diffDays() + ' ' + $t('days')"
              >
              </a-progress>
              <a-progress
                v-if="settings.status_license.condition == 'trial'"
                type="dashboard"
                status="active"
                :width="100"
                :percent="(diffDays() * 100) / 15"
                :format="() => diffDays() + ' ' + $t('days')"
              >
              </a-progress>
            </a-tooltip>
            <p v-if="settings.status_license.condition == 'full'">
              {{ $t("License period") }}
              <a-tag color="blue"> 365 {{ $t("days") }} </a-tag>
            </p>
            <p v-if="settings.status_license.condition == 'trial'">
              {{ $t("Trial") }}
              <a-tag color="blue"> 15 {{ $t("days") }} </a-tag>
            </p>

            <a-form-item :label="$t('license')">
              <a-tooltip>
                <template slot="title">{{ $t("license key") }}</template>
                <a-input
                  :disabled="settings.status_license.condition == 'full'"
                  v-decorator="[
                    `licenseKey`,
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('license key') + $t('required_field'),
                        },
                      ],
                      initialValue:
                        settings.status_license.condition == 'full'
                          ? settings.license.lic_key
                          : '',
                    },
                  ]"
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item
          align="center"
          :label-col="{ span: 0 }"
          :wrapper-col="{ span: 24 }"
        >
          <a-button
            :disabled="settings.status_license.condition == 'full'"
            type="primary"
            html-type="submit"
            >{{ $t("Save") }}</a-button
          >
        </a-form-item>
      </a-form>
    </a-col>
  </a-row>
</template>
<script>
import { saveSettings, saveMatrix, saveLicense } from "../requestFunc";
import moment from "moment";
export default {
  props: ["settings", "user_val"],
  data() {
    return {
      domain: null,
      keyword: [],
      form_main: this.$form.createForm(this, { name: "set_main" }),
      form_matrix: this.$form.createForm(this, { name: "set_matrix" }),
      form_license: this.$form.createForm(this, { name: "set_license" }),
      currentMenu: ["main"],
      matrixData: () => {
        var data = [];
        let matrix_item = 0;
        if (this.settings["my_company"])
          for (let item of this.settings["my_company"]) {
            matrix_item = this.settings["matrix"][item.ID];
            // console.log("matrix_item");
            // console.log(matrix_item);
            if (matrix_item != undefined) {
              data.push({
                ID: item.ID,
                SRC: this.domain + item.ID + "/",
                TITLE: item.TITLE,
                UF_CRM_PROJ_ASSIS: this.getUser(item.ASSIGNED_BY_ID),
                UF_CRM_HUBLIDER:
                  this.getUser(matrix_item.HUBLIDER) != undefined
                    ? this.getUser(matrix_item.HUBLIDER)
                    : "",
                respForProc:
                  this.getUser(matrix_item.respForProc) != undefined
                    ? this.getUser(matrix_item.respForProc)
                    : "",
                switchDefault:
                  matrix_item["RIGHT"] && matrix_item["RIGHT"] == "true"
                    ? matrix_item["RIGHT"]
                    : false,
              });
            } else {
              data.push({
                ID: item.ID,
                SRC: this.domain + item.ID + "/",
                TITLE: item.TITLE,
                UF_CRM_PROJ_ASSIS: this.getUser(item.ASSIGNED_BY_ID),
                UF_CRM_HUBLIDER: "",
                respForProc: "",
                switchDefault: false,
              });
            }
          }
        return data;
      },
    };
  },
  methods: {
    moment,
    diffDays() {
      if (this.settings.status_license.condition == "full")
        return moment(this.settings.license.lic_end_date).diff(
          moment(),
          "days"
        );
      if (this.settings.status_license.condition == "trial")
        return moment(this.settings.license.trial_end_date).diff(
          moment(),
          "days"
        );
    },
    userDefault(item, field) {
      console.log(item, field, 'test');
      let user = this.settings.data_user.find(
        (u) => u.NAME + " " + u.LAST_NAME == item[field]
      );
      return user ? user.ID : null;
    },
    getUser(id) {
      let user = this.settings["data_user"].find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : "";
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    handleSubmit_main(e) {
      e.preventDefault();
      this.form_main.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning();

          saveSettings(values)
            .done((res) => {
              let vals = JSON.parse(res);
              console.log(vals);
              this.$message.success(this.$t("Settings have been saved!"));
              // this.$emit("updateFiles", {
              //   files: vals.all_file,
              //   settings: {
              //     words: values.words,
              //     folder: values.folder,
              //     companyType: values.companyType,
              //     responsible: values.responsible,
              //     SPECJALIZACJA: values.SPECJALIZACJA,
              //     nip: values.nip,
              //     nip_field: values.nip_field,
              //     mail_folder: values.mail_folder,
              //     mail_user: values.mail_user,
              //   },
              // });
              this.$emit("loadFilesAndSettings");
              this.$emit("changeTab", true);
            })
            .fail((e) => {
              console.error(e);
              this.$message.error(this.$t("Error"));
            })
            .always(() => {
              this.changeSpinning();
            });
        }
      });
    },
    handleSubmit_matrix(e) {
      e.preventDefault();
      this.form_matrix.validateFields((err, values) => {
        var access_matrix = [];
        for (let [company, vals] of Object.entries(values)) {
          access_matrix.push({
            ...vals,
            COMPANY_ID: company,
          });
        }
        this.changeSpinning();
        saveMatrix(access_matrix)
          .done(() => {
            // let files = JSON.parse(res);
            // this.$emit("updateFiles", {
            //   files: files,
            // });
            this.$message.success("Access have been saved!");
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Error"));
          })
          .always(() => {
            this.changeSpinning();
          });
      });
    },
    handleSubmit_license(e) {
      e.preventDefault();
      this.form_license.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning(); 
        saveLicense(values.licenseKey)
          .done((res) => {
            let st = JSON.parse(res);
            // this.$emit("updateFiles", {
            //   files: files,
            // });
            if (st.status == "success") {
              this.$emit("loadFilesAndSettings");
              this.$emit("changeTab", true);
              this.$message.success("License have been saved!");
            } else {
              this.form_license.resetFields();
              this.$message.error(this.$t("Error"));
            }
          })
          .fail((e) => {
            this.form_license.resetFields();
            console.error(e);
            this.$message.error(this.$t("Error"));
          })
          .always(() => {
            this.changeSpinning();
          });
        }
      
      });
    },
    resize() {
      // eslint-disable-next-line
      BX24.resizeWindow(
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "width"
          )
        ),
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "height"
          )
        )
      );
    },
  },
  mounted() {
    console.log(this.settings, 'settings')
    console.log(this.user_val, 'user_val')
    this.keyword = this.user_val.SPECJALIZACJA;
    // eslint-disable-next-line
    let auth = BX24.getAuth();
    this.domain = " https://" + auth.domain + "/crm/company/details/";
    this.resize();
  },
  updated() {
    this.resize();
  },
};
</script>

<style scoped>
.settingsApp {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.settingsApp h2 {
  font-size: 24px;
}
.matrix__elem {
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 10px 10px 20px #c9c9c9, 0px 0px 0px #ffffff;
}
.matrix__elem .title {
  padding: 10px 0;
  font-size: 16px;
  border-bottom: 1px solid lightskyblue;
}
.matrix__elem .hubLeader {
  text-align: left;
  padding: 10px 15px 0 15px;
}
.matrix__elem .projectAssistant {
  text-align: left;
  padding: 10px 15px 0 15px;
}
.matrix__elem .responsibleForProcessing {
  text-align: left;
  padding: 10px 15px 0 15px;
}
.matrix__elem .private {
  text-align: left;
  padding: 10px 15px 0 15px;
}
#settings_main_form .ant-form-item-control-wrapper {
  text-align: left;
}
</style>
